// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"footer_footer-wrapper__KrhXH","footer":"footer_footer__oKj2d","logo":"footer_logo__mTSxd","menu":"footer_menu__reSBu","no-hover":"footer_no-hover__lohep"};